export default (store) => ({
  layout: { classNames: ['order-reports-layout'] },
  path : '/order_reports',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'OrderReports' */
      './components/OrderReports'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
